var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedemption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9993 0H16.0007C7.16377 0 0 7.16377 0 16.0007V23.9993C0 32.8362 7.16377 40 16.0007 40H23.9993C32.8362 40 40 32.8362 40 23.9993V16.0007C40 7.16377 32.8362 0 23.9993 0Z",
    fill: "#EFEDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.854 11.7396H10.9741C9.9738 11.7396 9.16492 12.5485 9.16492 13.5488V18.4418C10.0857 18.4418 10.8332 19.1893 10.8332 20.1101C10.8332 21.0309 10.0857 21.7784 9.16492 21.7784V26.6715C9.16492 27.6717 9.9738 28.4806 10.9741 28.4806H20.854C21.8543 28.4806 22.6632 27.6717 22.6632 26.6715V13.5524C22.6632 12.5521 21.8543 11.7432 20.854 11.7432V11.7396Z",
    stroke: "#8E7EC1",
    strokeWidth: 4.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1632 20.1065C29.1632 19.1857 29.9107 18.4382 30.8315 18.4382V13.5452C30.8315 12.5449 30.0226 11.736 29.0223 11.736H24.4724C23.4721 11.736 22.6632 12.5449 22.6632 13.5452V26.6643C22.6632 27.6645 23.4721 28.4734 24.4724 28.4734H29.0223C30.0226 28.4734 30.8315 27.6645 30.8315 26.6643V21.7712C29.9107 21.7712 29.1632 21.0237 29.1632 20.1029V20.1065Z",
    stroke: "#8E7EC1",
    strokeWidth: 4.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedemption);
export default __webpack_public_path__ + "static/media/redemption.a40ac96a009a4e918ee0b75ca60fb307.svg";
export { ForwardRef as ReactComponent };